import React from "react";
import Form from "./Form";

export default function New(props) {
  const { filter, appProps, app, name, monetizationPath, isMultiLangOrRegion, ...otherProps } = props;
  return (
    <Form {...{filter, appProps, app, isMultiLangOrRegion, name, monetizationPath}} data={{ type: `Tier::${filter}` }} />
  );
}
